/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateFaqCategoryDto } from '../../models/lexplus-create-faq-category-dto';
import { LexplusDropdownMiniDto } from '../../models/lexplus-dropdown-mini-dto';

export interface FaqControllerCreateCategoryV1$Params {
      body: LexplusCreateFaqCategoryDto
}

export function faqControllerCreateCategoryV1(http: HttpClient, rootUrl: string, params: FaqControllerCreateCategoryV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusDropdownMiniDto>> {
  const rb = new RequestBuilder(rootUrl, faqControllerCreateCategoryV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusDropdownMiniDto>;
    })
  );
}

faqControllerCreateCategoryV1.PATH = '/v1/faq/categories';
